/**
 * Type for page-specific logout handlers
 * Return true to proceed with logout, false to cancel
 */
export type LogoutHandler = () => Promise<boolean> | boolean;

/**
 * Registry of page-specific logout handlers
 * Key: route path, Value: handler function
 */
const logoutHandlers: Record<string, LogoutHandler> = {};

/**
 * Register a logout handler for a specific page
 */
export const registerLogoutHandler = (path: string, handler: LogoutHandler) => {
  logoutHandlers[path] = handler;
};

/**
 * Get logout handler for a specific page
 */
export const getLogoutHandler = (path: string): LogoutHandler | undefined => {
  return logoutHandlers[path];
};

/**
 * Execute logout handler for current page
 * Returns true if logout should proceed, false if cancelled
 */
export const executeLogoutHandler = async (
  currentPath: string
): Promise<boolean> => {
  const handler = getLogoutHandler(currentPath);

  if (!handler) {
    return true; // No handler for this page, proceed with logout
  }

  try {
    return await handler();
  } catch (error) {
    return false; // Don't logout on error
  }
};
